module.exports = __webpack_public_path__ + "cz.svg?638b7cdc97079482909e14375f1895ca";